"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A handler for converting GraphQL value nodes to terms and patterns.
 */
class NodeValueHandlerAdapter {
    constructor(targetKind, util, settings) {
        this.targetKind = targetKind;
        this.util = util;
        this.settings = settings;
    }
}
exports.NodeValueHandlerAdapter = NodeValueHandlerAdapter;
//# sourceMappingURL=NodeValueHandlerAdapter.js.map